/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'pip-model',
  'pip-events',
  'pip-common.quantity',
  'pip-common.utils',
  'mustache'
], function(
  $,
  pip,
  pipEvents,
  pipQuantity,
  pipCommonUtils,
  Mustache
) {

  var view = {
    selectors: {
      quantityBoxSelector: '#buybox__quantity',
      quantityBoxSelectorInput: '#buybox__quantity__input',
      minimumQuantityMessageContainer: '.buybox__quantity__minimum-message-container',
      buyboxQuantityInput: '#buybox__quantity__input'
    },
    templates: {
      minimumQuantityMessage: $('#minimum-quantity-message').html()
    },
    classes: {
      minimumQuantityState: 'buybox__quantity__input--minimum-state',
      buyboxQuantityError: 'buybox__quantity--error'
    },
    render: {
      minimumQuantityMessage: function renderMinimumQuantityMessage(minimumQuantity) {
        return Mustache.render(view.templates.minimumQuantityMessage, {minimumQuantity: minimumQuantity});
      }
    },
    updateDom: {
      minimumQuantityMessage: function updateMinimumQuantityMessage(minimumQuantity) {
        $(view.selectors.minimumQuantityMessageContainer).html(view.render.minimumQuantityMessage(minimumQuantity));
      },
      addMinimumQuantityState: function addMinimumQuantityState() {
        $(view.selectors.buyboxQuantityInput).addClass(view.classes.minimumQuantityState);
      },
      removeMinimumQuantityState: function removeMinimumQuantityState() {
        $(view.selectors.buyboxQuantityInput).removeClass(view.classes.minimumQuantityState);
      }
    }

  };

  var isErrorState;
  var isOnlineErrorState;

  function initQuantityLimitListeners() {
    pipEvents.pipModel.pipModelQuantityUpdated.off('.quantityErrorState');
    pipEvents.pipModel.pipModelQuantityUpdated.on('.quantityErrorState', checkQuantityErrorState);

    pipEvents.calculator.quantityCalculatorStateChanged.off('.quantityCalculatorStateChanged');
    pipEvents.calculator.quantityCalculatorStateChanged.on('.quantityCalculatorStateChanged', function () {
      if (pip.features.minimumOrderQuantityEnabled
          && pip.customer.minimumQuantity
          && pip.viewModel.calculator.calculated.numberOfUnitsNeeded < pip.customer.minimumQuantity
        ) {
        pip.customer.quantity = pip.customer.minimumQuantity;
        pipEvents.pipModel.pipModelQuantityUpdated.trigger();
        pipEvents.quantity.minimumQuantityWarning.trigger();
        return;
      }
      pip.customer.quantity = pip.viewModel.calculator.calculated.numberOfUnitsNeeded;
      if (pip.features.minimumOrderQuantityEnabled) {
        pipEvents.quantity.clearMinimumQuantityWarning.trigger();
      }
      pipEvents.pipModel.pipModelQuantityUpdated.trigger();
    });
  }

  function checkQuantityErrorState() {
    if ((pip.fulfillment.store && pip.fulfillment.store.buyOnlinePickUpInStore
        && pip.inventory && pip.inventory.store && pip.inventory.store.isInStock)
      || (pip.inventory && pip.inventory.nearbyStore && pip.inventory.nearbyStore.isInStock)) {

      var hasErrorStateChanged = false;
      var isEnoughItemsInStore = pip.inventory.nearbyStore
        ? pip.customer.quantity <= pip.inventory.nearbyStore.quantity
        : pip.customer.quantity <= pip.inventory.store.quantity;

      if (!isErrorState && !isEnoughItemsInStore) {
        $(view.selectors.quantityBoxSelectorInput).addClass(view.classes.buyboxQuantityError);
        pip.customer.errorState = { quantityGreaterThanAvailableQuantity: true };
        isErrorState = true;
        hasErrorStateChanged = true;
      }

      if (isErrorState && isEnoughItemsInStore) {
        $(view.selectors.quantityBoxSelectorInput).removeClass(view.classes.buyboxQuantityError);
        pip.customer.errorState = { quantityGreaterThanAvailableQuantity: false };
        isErrorState = false;
        hasErrorStateChanged = true;
      }

      if (hasErrorStateChanged) pipEvents.customer.customerQuantityErrorStateChanged.trigger({ isErrorState: isErrorState });
    }
    if (pip.features.sharedSkuOnlineQuantityEnabled) {
      checkOnlineQuantityErrorState();
    }
  }

  function checkOnlineQuantityErrorState() {
    if (pipCommonUtils.deepGet(pip, "inventory.online.quantity")) {
      var isEnoughItemsOnline = pip.customer.quantity <= pip.inventory.online.quantity;

      var hasOnlineErrorStateChanged = false;
      if (!isOnlineErrorState && !isEnoughItemsOnline) {
        if (pip.products.primary.data.availabilityType === "Online") {
          $(view.selectors.quantityBoxSelectorInput).addClass(view.classes.buyboxQuantityError);
        }
        pip.customer.errorState = { onlineQuantityGreaterThanAvailableQuantity: true };
        isOnlineErrorState = true;
        hasOnlineErrorStateChanged = true;
      }

      if (isOnlineErrorState && isEnoughItemsOnline) {
        if (pip.products.primary.data.availabilityType === "Online") {
          $(view.selectors.quantityBoxSelectorInput).removeClass(view.classes.buyboxQuantityError);
        }
        pip.customer.errorState = { onlineQuantityGreaterThanAvailableQuantity: false };
        isOnlineErrorState = false;
        hasOnlineErrorStateChanged = true;
      }

      if (hasOnlineErrorStateChanged) {
        pipEvents.customer.customerOnlineQuantityErrorStateChanged.trigger({ isErrorState: isOnlineErrorState});
        if (pip.products.primary.data.availabilityType === "Online") {
          pipEvents.customer.customerQuantityErrorStateChanged.trigger({ isErrorState: isOnlineErrorState });
        }
      }
    }

  }

  function displayQuantity() {
    if (pip.fulfillment.fulfillable) {
      $('.buybox .align-bottom').fadeIn(300);
    }
  }

  function initEventListeners() {
    pipEvents.dualPath.dualPathOptInStateChanged.off('.quantityDualPathStateChanged');
    pipEvents.dualPath.dualPathOptInStateChanged.on('.quantityDualPathStateChanged', function() {
      $(view.selectors.quantityBoxSelector).toggle(!pip.customer.dualPath.isOptedIn);
    });

    pipEvents.quantity.minimumQuantityWarning.off('.minimumQuantityWarning');
    pipEvents.quantity.minimumQuantityWarning.on('.minimumQuantityWarning', function() {
      view.updateDom.addMinimumQuantityState();
    });
    pipEvents.quantity.clearMinimumQuantityWarning.off('.clearMinimumQuantityWarning');
    pipEvents.quantity.clearMinimumQuantityWarning.on('.clearMinimumQuantityWarning', function() {
      view.updateDom.removeMinimumQuantityState();
    });
  }

  return {
    init: function init() {
      isErrorState = false;
      isOnlineErrorState = false;

      var minimumQuantity = pipCommonUtils.deepGet(pip, 'products.primary.data.info.minimumOrderQuantity');
      if(typeof minimumQuantity === "string") {
        minimumQuantity = parseInt(minimumQuantity);
      }
      if (minimumQuantity && pip.features.minimumOrderQuantityEnabled) {
        pip.customer.minimumQuantity = minimumQuantity;
        pip.customer.quantity = minimumQuantity;
        view.updateDom.minimumQuantityMessage(minimumQuantity);
        pipQuantity.create(view.selectors.quantityBoxSelector, minimumQuantity);
      } else {
        pipQuantity.create(view.selectors.quantityBoxSelector);
      }

      initQuantityLimitListeners();
      checkQuantityErrorState();

      displayQuantity();
      initEventListeners()
    },
    checkQuantityErrorState: checkQuantityErrorState,
    checkOnlineQuantityErrorState: checkOnlineQuantityErrorState
  }
});

}.call(window));